<template>
  <div class="app-layout">
    <AppNavbar />
    <div v-if="isImpersonating && !isAdminPage" class="app-layout__impersonation-bar">
      <a
        :href="adminOrgUrl"
        class="app-layout__back-to-admin">
        Back to admin
        <i class="fa-solid fa-chevron-right" />
      </a>
      <a
        href="/users/stop_impersonating"
        data-method="post"
        class="app-layout__stop-impersonating">
        <i class="fa-solid fa-xmark" />
      </a>
    </div>
    <div class="app-layout__body">
      <AppSidebar v-if="sidebar" />
      <main class="app-layout__main" :class="{ '!p-0': noPadding }">
        <OrgAlerts />
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'
import AppNavbar from '@/components/layout/navbar'
import AppSidebar from '@/components/layout/sidebar'
import OrgAlerts from '@/components/layout/org-alerts'

defineProps({
  noPadding: { type: Boolean, default: false }
})

const globalStore = useGlobalStore()
const sidebar = computed(() => globalStore.sidebar)
const isImpersonating = computed(() => globalStore.user?.impersonating)
const isAdminPage = window.location.pathname.startsWith('/admin')
const adminOrgUrl = computed(() => {
  const orgId = globalStore.organization?.obfuscatedId
  return orgId ? `/admin/organizations/${orgId}` : '/admin/organizations'
})
</script>
